/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';

import { DataTableList } from '../../components/DataTable/DataTableList';
import TopBar from '../../components/TopBar'
import AddNewSubscriber from './AddNewSubscriber';
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg";
import searchIcon from "../../assets/images/icon-search.svg";

import { getSubscribers, deleteSubscribers, createSubscriber, getAllSubscribersWithoutPagination } from '../../api/subscribersApi';
import { exportToCSV } from '../../utils/functions';

import '../../assets/css/customer.css'

const Subscribers = () => {

    const popupRef = useRef();
    const deletePopupRef = useRef()

    const [subscriberList, setSubscriberList] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);

    const [isNewUserCreate, setIsNewUserCreate] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const [searchInput, setSearchInput] = useState('');
    const [error, setError] = useState('')
    const [isExportLoading, setIsExportLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        city: "",
        mobileNumber: ""
    });
    const [errorMessage, setErrorMessage] = useState({
        name: "",
        city: "",
        mobileNumber: ""
    });

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (deletePopupRef.current && !deletePopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }

            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsNewUserCreate(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const fetchSubscribers = async () => {
        setIsLoadingData(true)
        try {
            const response = await getSubscribers({
                page: currentPage,
            });

            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false)
            }

            setSubscriberList(response?.data?.result);
            setTotalPage(response?.data?.totalPages || 1);
        } catch (error) {
            setSubscriberList([]);
            setIsLoadingData(false);
        }
    };

    useEffect(() => {
        fetchSubscribers();
    }, [currentPage]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrorMessage({ ...errorMessage, [e.target.name]: '' });
    };

    const openAddPopup = () => {
        setFormData({
            name: "",
            city: "",
            mobileNumber: ""
        });
        setIsNewUserCreate(true);
        setErrorMessage({
            name: "",
            city: "",
            mobileNumber: "",
        })
        setError('')
    };

    const validateForm = () => {
        let errors = {};

        if (!formData.name?.trim()) {
            errors.name = "Name is required";
        }

        if (!formData.mobileNumber?.trim()) {
            errors.mobileNumber = "Mobile number is required";
        } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
            errors.mobileNumber = "Mobile number must be exactly 10 digits";
        }

        setErrorMessage(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        try {
            setIsLoading(true);

            await createSubscriber({
                name: formData.name,
                city: formData.city,
                mobileNumber: formData.mobileNumber
            });

            let updatedList = [formData, ...subscriberList];
            setSubscriberList(updatedList)
            setFormData({
                name: '',
                city: '',
                mobileNumber: ''
            })
            setIsNewUserCreate(false);
            fetchSubscribers();
        } catch (error) {
            console.log({error})
            const message =
                error?.response?.data?.error?.message ||
                'Something went wrong. Please try again.';
            setError(message);
            console.log('Error saving subscriber:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = subscriberList?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    let dataValue;
                    let title;

                    if (key === 'name') {
                        dataValue = `${row?.name}`;
                        title = 'Name';
                    } else {
                        dataValue = row[key]?.toString();
                        title = key;
                    }

                    let maxContentLength = Math.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    useEffect(() => {
        if (subscriberList?.length > 0) {
            calculateColumnWidths();
        }
    }, [subscriberList]);

    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(subscriberList?.map((row) => row?.id));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleExportAllCSV = async () => {
        try {
            setIsExportLoading(true)
            const response = await getAllSubscribersWithoutPagination();
            const allData = response?.data || [];

            const columns = [
                { name: 'Name', selector: (row) => row.name },
                { name: 'Location', selector: (row) => row.city },
                { name: 'Mobile Number', selector: (row) => row.mobileNumber },
            ];

            exportToCSV(allData, 'subscribers', columns);
        } catch (error) {
            console.log('Error exporting subscribers:', error);
        } finally {
            setIsExportLoading(false)
        }
    };

    const columns = [
        {
            name: 'Name',
            selector: (row) => row?.name,
            cell: (row) => <div>{row.name}</div>,
            sortable: true,
            minWidth: columnWidths['name'] ? `${parseInt(columnWidths['name']) + 50}px` : '150px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Location',
            selector: (row) => row?.city,
            cell: (row) => <div>{row.city || '-'}</div>,
            sortable: true,
            width: columnWidths['city'] || '120px',
            style: { width: columnWidths['city'] || '120px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Mobile Number',
            selector: (row) => row?.mobileNumber,
            cell: (row) => <div>{row.mobileNumber}</div>,
            sortable: true,
            width: columnWidths['mobileNumber'] || '150px',
            style: { width: columnWidths['mobileNumber'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <button className="edit-btn"><Link to={`/subscriber/${row?.id}`}><img src={penIcon} alt="pen-icon" /></Link></button>
                    <button className="delete-btn" onClick={() => {
                        setDeleteTarget({ type: "single", row });
                        setShowDeletePopup(true);
                        setError('')
                    }}><img src={Delete} alt="delete-icon" /></button>
                </div>
            ),
            width: "90px"
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            setIsLoading(true);

            if (deleteTarget.type === "single") {
                await deleteSubscribers([deleteTarget.row.id]);
                setSubscriberList(prev =>
                    prev.filter(item => item.id !== deleteTarget.row.id)
                );
            } else if (deleteTarget.type === "multiple") {
                await deleteSubscribers(deleteTarget.rows);
                setSubscriberList(prev =>
                    prev.filter(item => !deleteTarget.rows.includes(item.id))
                );
            }

            setSelectedRows([]);
            setIsAllSelected(false);
            setToggleSelect(prev => !prev);
            fetchSubscribers();
        } catch (error) {
            console.error('Error deleting subscribers:', error);
        } finally {
            setIsLoading(false);
            setShowDeletePopup(false);
            setDeleteTarget(null);
        }
    };

    const handleSearch = async () => {
        try {
            setIsLoadingData(true)
            const response = await getSubscribers({ search: searchInput })
            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false)
            }
            setSubscriberList(response?.data?.result);
            setTotalPage(response?.data?.totalPages || 1);
            setIsLoadingData(false)
        } catch (error) {
            setIsLoadingData(false)
            console.log(error, "error");
        }
    }

    return (
        <div className={`customer-page ${subscriberList?.length <= 10 && 'customer-page-height'}`}>
            <TopBar />
            <div className='customer-datatable-list'>
                <div className="customer-header">
                    <div className="customer-left-side">
                        <div className="search-bar">
                            <img src={searchIcon} alt="Search" />
                            <input
                                type="text"
                                placeholder="Search subscribers..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch(searchInput)}
                            />
                        </div>
                        <button className="add-btn" onClick={() => handleSearch(searchInput)}>Search</button>
                    </div>
                    <div className='action-buttons-delete-add'>
                        <button className="add-btn export-subscriber-btn" onClick={handleExportAllCSV}>
                            {isExportLoading ? (
                                <div className={`ringLoader loaderContinue`}></div>
                            ) :
                                'Export Subscribers'
                            }
                        </button>
                        <button className="add-btn" onClick={openAddPopup}>Add New Subscriber</button>
                        {selectedRows?.length > 0 && (
                            <div className="delete-selected-btn" onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`pagesTable dataTable-list ${subscriberList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={subscriberList}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows.map((row) => row.id);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds.length === subscriberList.length);
                        }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    />
                </div>
            </div>

            <AddNewSubscriber
                isNewUserCreate={isNewUserCreate}
                formData={formData}
                handleSubmit={handleSubmit}
                setIsNewUserCreate={setIsNewUserCreate}
                handleChange={handleChange}
                refrence={popupRef}
                errorMessage={errorMessage}
                isLoading={isLoading}
                error={error}
            />

            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={deletePopupRef}
                title={deleteTarget?.type === "single" ? 'subscriber' : selectedRows?.length === 1 ? 'subscriber' : `subscribers`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.name}?` : selectedRows?.length === 1 ? `Are you sure you want to delete subscriber?` : `Are you sure you want to delete ${selectedRows?.length} subscribers?`}
                confirmDelete={confirmDelete}
            />
        </div>
    )
}

export default Subscribers
